import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

type UserNameRow = { id: string; nome: string | null };

export function useUserNamesByIds(userIds: Array<string | null | undefined>) {
  const { loading } = useAuth();

  const ids = useMemo(() => {
    const unique = new Set<string>();
    for (const id of userIds) {
      if (typeof id === "string" && id.trim()) unique.add(id);
    }
    return Array.from(unique);
  }, [userIds]);

  return useQuery({
    queryKey: ["profiles", "names-by-ids", ids],
    enabled: !loading && ids.length > 0,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("profiles")
        .select("id, nome")
        .in("id", ids);

      if (error) throw error;

      const map: Record<string, string> = {};
      for (const row of (data || []) as UserNameRow[]) {
        if (row?.id) map[row.id] = row.nome || "Usuário";
      }
      return map;
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}

